<script setup>
/* global axios */
// "Olustur": Icerik bolumunun kalbi.
//
// Kullanicinin isi "Instagram yonetmek" degil: olustur -> planla -> yayinla ->
// sonucunu gor. Bu yuzden ekran hesap bazli DEGIL: tek metin yazilir, birden
// fazla hesap kutucugu isaretlenir, gonderi hepsine ayni anda gider.
//
// Sunucudaki karsiligi iki parcali (OmnupGonderi + OmnupGonderiHedefi): her
// hedefin KENDI durumu ve hatasi var. Gonderinin Instagram'a gidip Facebook'a
// gitmemesi olagan bir sonuctur, bu yuzden yayindan sonra sonuclari hedef
// hedef gosteriyoruz.
//
// AKIS iki adimdir: once kayit olusur (POST icerik), sonra o kaydin yayinla ucu
// cagrilir (POST icerik/:id/yayinla). Tek adimda yapmiyoruz; Meta tarafi hata
// verirse kullanicinin metni kaybolmasin, kayit listede dursun ve tekrar
// denenebilsin.
//
// Platforma ozel HER SEY icerik-platformlar.js'teki yetenek tablosundan geliyor.
// Bu dosyada "eger Instagram ise" turunden bir dal YOK; yeni bir platform
// eklendiginde burasi degismez.
//
// Ham 'axios' PAKETINI ice aktarmiyoruz. Chatwoot kimlik basliklarini
// window.axios uzerinde tutuyor; paketten gelen ornek 401 doner.
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import { useAdmin } from 'dashboard/composables/useAdmin';
import Button from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import IcerikOnizleme from './IcerikOnizleme.vue';
import IcerikPlatformSecenek from './IcerikPlatformSecenek.vue';
import {
  DURUM_ANAHTARLARI,
  DURUM_RENKLERI,
  HEDEF_DURUM_ANAHTARLARI,
  HEDEF_DURUM_RENKLERI,
  hataMetniniCoz,
  yerelAlanMetni,
  zamanMetni,
} from './icerik-ortak';
import {
  AZAMI_MEDYA,
  metinSiniri,
  platformKurali,
  varsayilanAyar,
  yayinEngelleri,
  yayinUyarilari,
} from './icerik-platformlar';

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();
const { isAdmin } = useAdmin();

const uc = computed(() => `/api/v1/accounts/${route.params.accountId}/icerik`);
const medyaUcu = computed(() => `${uc.value}/medya`);

// Ekran hem YENI hem DUZENLEME icin calisir. Liste, Takvim ve Genel Bakis
// ekranlari duzenlemeyi "?gonderi=12" ile aciyor; takvimde bos bir gune
// tiklamak da "?zaman=2026-09-20T09:00" tasiyor. Ikisini de okuyoruz -
// gonderilen bir parametreyi yok saymak, kullaniciyi ayni secimi ikinci kez
// yapmaya zorlamak olurdu.
const acilistakiId = computed(() => route.query.gonderi || null);
const acilistakiZaman = computed(() => route.query.zaman || '');

// --- durum -----------------------------------------------------------------

const hesaplar = ref([]);
const hesapYukleniyor = ref(true);
const hesapHatasi = ref('');

const gonderiId = ref(null);
const gonderiDurumu = ref('taslak');
const redSebebi = ref('');
const hedefler = ref([]);

const secili = ref([]);
const metin = ref('');
const medya = ref([]);
const secenekler = ref({});

const planAcik = ref(false);
const planZamani = ref('');

const kaydediliyor = ref(false);
const islem = ref('');
const formHatasi = ref('');

const medyaPaneli = ref(false);
const kutuphane = ref([]);
const kutuphaneYukleniyor = ref(false);
const kutuphaneHatasi = ref('');
const dosyaYukleniyor = ref(false);

const hataMetni = e => hataMetniniCoz(e, t('ICERIK.HATA_BILINMEYEN'));

// --- turetilenler ----------------------------------------------------------

const seciliHesaplar = computed(() =>
  hesaplar.value.filter(h => secili.value.includes(h.inbox_id))
);

// Secili hesaplarin platformlari, tekrarsiz. Iki Instagram hesabi secili olsa
// da "Instagram secenekleri" bolumu BIR kez cizilir: ayarlar gonderiye ait,
// hesaba degil.
const aktifPlatformlar = computed(() => [
  ...new Set(seciliHesaplar.value.map(h => h.platform).filter(Boolean)),
]);

const platformHesaplari = platformAdi =>
  seciliHesaplar.value.filter(h => h.platform === platformAdi);

// Baglantisi dusmus hesaplar. Secimi ENGELLEMIYORUZ - jeton kullanici
// yenileyene kadar oyle kalir ve gonderiyi simdiden hazirlamak isteyebilir -
// ama sessiz kalmak da yayin aninda surpriz hata demek.
const sorunluHesaplar = computed(() =>
  seciliHesaplar.value.filter(h => h.yayinlanabilir === false)
);

const sinirKurali = computed(() => metinSiniri(aktifPlatformlar.value));
const metinUzunlugu = computed(() => metin.value.length);
const sinirAsildi = computed(
  () =>
    Boolean(sinirKurali.value) &&
    metinUzunlugu.value > sinirKurali.value.metinSiniri
);

const engeller = computed(() =>
  yayinEngelleri({
    platformlar: aktifPlatformlar.value,
    metin: metin.value,
    medya: medya.value,
    secenekler: secenekler.value,
  })
);

const uyarilar = computed(() =>
  yayinUyarilari({
    platformlar: aktifPlatformlar.value,
    medya: medya.value,
    secenekler: secenekler.value,
  })
);

// Engel ve uyari metinleri i18n'de; kodda yalnizca anahtar ve sayilar var.
// veri.platform bir ANAHTAR tasiyor (hangi platform siniri daraltiyor), once
// onu cevirmemiz gerekiyor.
const olcuMetni = kayit => {
  if (!kayit) return '';
  const veri = { ...kayit.veri };
  if (veri.platform) veri.platform = t(veri.platform);
  return t(kayit.anahtar, veri);
};

const bosMu = computed(() => !metin.value.trim() && !medya.value.length);
const yayinlanabilir = computed(() => engeller.value.length === 0);

// Sunucunun duzenlemeye kapattigi durumlar (denetleyicideki KILITLI_DURUMLAR).
// Yayinlanmis gonderinin metnini burada degistirmek Meta'daki gonderiyi
// degistirmez; formu acik birakmak kullaniciyi 422 duvarina surerdi. 'kismi'
// BILEREK yok: bir kismi cikmamis gonderi duzeltilip yeniden yayinlanabilir,
// yayin servisi cikmis hedefleri atliyor.
const KILITLI_DURUMLAR = ['yayinlaniyor', 'yayinlandi'];
const kilitli = computed(() => KILITLI_DURUMLAR.includes(gonderiDurumu.value));
// AZAMI_MEDYA 1 iken yeni secim eskisinin YERINE geciyor; dugmeyi kapatmak
// kullaniciyi once silip sonra eklemeye zorlardi.
const medyaEklenebilir = computed(
  () => AZAMI_MEDYA === 1 || medya.value.length < AZAMI_MEDYA
);
const islemde = ad => kaydediliyor.value && islem.value === ad;

// --- kirlilik --------------------------------------------------------------
//
// Kaydedilmemis degisiklikle sayfadan cikmak, yazilmis bir gonderiyi cope
// atmak demek. Karsilastirmayi ALANLARIN KENDISINDEN uretiyoruz; ayri bir
// "degisti" bayragini her yerde elle guncellemek er gec unutulur.

const imza = () =>
  JSON.stringify({
    metin: metin.value,
    secili: [...secili.value].sort(),
    medya: medya.value.map(m => m.id),
    secenekler: secenekler.value,
    plan: planZamani.value,
  });

const temizImza = ref(imza());
const kirli = computed(() => imza() !== temizImza.value);

// NEDEN nextTick: platform secilince ayar kutusu bir izleyici tarafindan
// varsayilanlarla dolduruluyor ve bu, imzayi biz yazdiktan SONRA degistiriyor.
// Tazelemeyi bir tik geciktirmezsek ekran daha acilir acilmaz "kaydedilmemis
// degisiklik var" der ve cikista bos yere uyari cikar.
const imzayiTazele = async () => {
  await nextTick();
  temizImza.value = imza();
};

// --- zaman -----------------------------------------------------------------

const zamanYazisi = deger => zamanMetni(deger, locale.value);

const isoyaCevir = alanDegeri => {
  const tarih = new Date(alanDegeri);
  if (Number.isNaN(tarih.getTime())) return null;
  // Sunucuya ISO 8601 (UTC) gidiyor: kullanicinin saat dilimini tasimayan ham
  // metin gonderirsek zamanlama saatler kayabilir.
  return tarih.toISOString();
};

const alanaCevir = iso => {
  if (!iso) return '';
  const tarih = new Date(iso);
  if (Number.isNaN(tarih.getTime())) return '';
  return yerelAlanMetni(tarih);
};

// Gecmis bir zaman secilmesini tarayici da engellesin. Computed degil islev:
// computed bir kez hesaplanip onbellekte kalirdi ve sekme uzun sure acik
// kalinca alt sinir gecmiste kalirdi.
const enErkenZaman = () => yerelAlanMetni(new Date());

// --- veri ------------------------------------------------------------------

const hesaplariYukle = async () => {
  hesapYukleniyor.value = true;
  hesapHatasi.value = '';
  try {
    const { data } = await axios.get(`${uc.value}/hesaplar`);
    // Sunucu tanimadigimiz bir platform bildirirse o hesabi CIZMIYORUZ:
    // secenekleri ve onizlemesi olmayan bir kutucuk, yarim bir ozellik
    // gostermek olurdu.
    hesaplar.value = (data.hesaplar || []).filter(h =>
      platformKurali(h.platform)
    );

    // Tek hesap varsa kendiliginden secili gelsin; var olan tek kutucugu
    // tiklatmak gereksiz bir adim. Birden fazlaysa SECMIYORUZ: yanlis hesaba
    // cikan gonderi geri alinamaz.
    if (!acilistakiId.value && hesaplar.value.length === 1) {
      secili.value = [hesaplar.value[0].inbox_id];
    }
  } catch (e) {
    hesapHatasi.value = hataMetni(e);
  } finally {
    hesapYukleniyor.value = false;
  }
};

// Sunucudan donen gonderiyi ekrana yazar.
const gonderiyiUygula = (veri, { formuDoldur }) => {
  gonderiId.value = veri.id;
  gonderiDurumu.value = veri.durum || 'taslak';
  redSebebi.value = veri.red_sebebi || '';
  hedefler.value = veri.hedefler || [];

  if (formuDoldur) {
    metin.value = veri.metin || '';
    // Gelen kutusu sonradan silinmis olabilir. Bilinmeyen bir kimligi secili
    // birakirsak ilk kaydetmede sunucu 404 doner ve kullanici, ekranda
    // gormedigi bir hesap yuzunden kaydedemez. Hedef satiri sunucuda duruyor;
    // burada yalnizca SECILEBILIR olanlari isaretliyoruz.
    const bilinen = new Set(hesaplar.value.map(h => h.inbox_id));
    secili.value = (veri.hedefler || [])
      .map(h => h.inbox_id)
      .filter(kimlik => bilinen.has(kimlik));

    // 'medya' bu kutunun icinde ama platform ayari DEGIL; form onu ayri
    // tutuyor ve kaydederken yeniden uretiyor.
    const ayarlar = { ...(veri.secenekler || {}) };
    delete ayarlar.medya;
    secenekler.value = ayarlar;

    planZamani.value = alanaCevir(veri.yayin_zamani);
    planAcik.value = Boolean(planZamani.value);
  }

  // Medya listesini HER ZAMAN sunucudan aliyoruz: adresler imzali ve suresi
  // kisa, ayrica kutuphaneden silinmis bir dosya listeden dusmus olur.
  medya.value = (veri.medya || []).filter(m => m && m.url);
};

const gonderiyiYukle = async kimlik => {
  try {
    const { data } = await axios.get(`${uc.value}/${kimlik}`);
    gonderiyiUygula(data, { formuDoldur: true });
  } catch (e) {
    formHatasi.value = hataMetni(e);
  }
};

// Yeni secilen platformun ayar kutusunu varsayilanlarla tamamliyoruz;
// kullanici hic dokunmasa bile gonderi anlamli bir ayarla gitsin.
//
// NEDEN "tamamlamak", "yazmak" degil: duzenlenen eski bir gonderide kutu zaten
// dolu olabilir ama yeni eklenmis bir secenek icin bos olur. Uzerine yazmak
// kullanicinin ayarini silerdi, hic dokunmamak da secicinin bos gorunmesine
// yol acardi.
watch(
  aktifPlatformlar,
  liste => {
    liste.forEach(ad => {
      const mevcut = secenekler.value[ad];
      const varsayilan = varsayilanAyar(ad);
      const eksikVar = Object.keys(varsayilan).some(
        alan => mevcut?.[alan] === undefined
      );
      if (mevcut && !eksikVar) return;

      secenekler.value = {
        ...secenekler.value,
        [ad]: { ...varsayilan, ...(mevcut || {}) },
      };
    });
  },
  { immediate: true }
);

const ayariYaz = (platformAdi, deger) => {
  secenekler.value = { ...secenekler.value, [platformAdi]: deger };
};

// Adres cubugundaki gonderi degisirse ekrani tazeliyoruz.
//
// NEDEN: bu ekran zaten aciksa (ornegin kullanici Olustur'dayken listeden
// baska bir gonderiyi duzenlemeye basarsa) bilesen yeniden kurulmaz,
// onMounted calismaz ve ekranda ESKI gonderi kalirdi - kullanici baskasinin
// metnini duzenledigini sanip yanlis kaydi degistirir.
watch(acilistakiId, async kimlik => {
  if (!kimlik || String(kimlik) === String(gonderiId.value)) return;

  await gonderiyiYukle(kimlik);
  await imzayiTazele();
});

// --- kaydetme --------------------------------------------------------------

// Gonderi govdesi. YALNIZCA secili platformlarin ayarlari gidiyor: kullanici
// Facebook'u secip ayarini degistirip sonra kutucugu kapattiysa, o ayarin
// gonderiyle birlikte dolasmasi anlamsiz ve ileride yanlis yorumlanir.
const seceneklerGovdesi = () => {
  const kutu = {};
  aktifPlatformlar.value.forEach(ad => {
    const ayar = { ...(secenekler.value[ad] || {}) };
    // Bos metin alanlarini hic yazmiyoruz: "" degeri jsonb'de "kullanici
    // burayi doldurdu" gibi durur.
    Object.keys(ayar).forEach(alan => {
      if (typeof ayar[alan] === 'string' && !ayar[alan].trim()) {
        delete ayar[alan];
      }
    });
    kutu[ad] = ayar;
  });
  kutu.medya = medya.value.map(m => ({ medya_id: m.id, url: m.url }));
  return kutu;
};

const kaydet = async (durum, iso) => {
  const govde = {
    gonderi: {
      metin: metin.value,
      durum,
      yayin_zamani: iso,
      inbox_idler: secili.value,
      secenekler: seceneklerGovdesi(),
    },
  };

  const { data } = gonderiId.value
    ? await axios.patch(`${uc.value}/${gonderiId.value}`, govde)
    : await axios.post(uc.value, govde);

  gonderiyiUygula(data, { formuDoldur: false });
  await imzayiTazele();
  return data;
};

// Planlama alanini dogrular; sorun varsa metnini doner.
const planSorunu = () => {
  if (!planZamani.value) return t('ICERIK.OLUSTUR.ZAMAN_ZORUNLU');
  const iso = isoyaCevir(planZamani.value);
  if (!iso) return t('ICERIK.OLUSTUR.ZAMAN_GECERSIZ');
  if (new Date(iso).getTime() <= Date.now()) {
    return t('ICERIK.OLUSTUR.ZAMAN_GECMIS');
  }
  return '';
};

const calistir = async (ad, is) => {
  formHatasi.value = '';
  kaydediliyor.value = true;
  islem.value = ad;
  try {
    await is();
  } catch (e) {
    formHatasi.value = hataMetni(e);
  } finally {
    kaydediliyor.value = false;
    islem.value = '';
  }
};

// TASLAK: en hosgorulu akis. Hesap secilmemis olabilir, gonderi eksik olabilir;
// tek sart metin ya da medya. Sunucu da hedefsiz taslagi kabul ediyor - fikir
// aklina gelen kullanici once yazar, hesabi sonra secer.
const taslakKaydet = () =>
  calistir('taslak', async () => {
    if (bosMu.value) {
      formHatasi.value = t('ICERIK.OLUSTUR.ENGEL_BOS');
      return;
    }
    await kaydet('taslak', null);
    useAlert(t('ICERIK.OLUSTUR.KAYDEDILDI'));
  });

// PLANLA: zamani gelince is kuyrugu yayinlayacak. Yayin engellerini SIMDI
// gosteriyoruz; yarin sabah 09:00'da sessizce hata veren bir gonderi en kotu
// sonuctur - kimse basinda degildir.
const planKaydet = () =>
  calistir('planla', async () => {
    const sorun = planSorunu();
    if (sorun) {
      formHatasi.value = sorun;
      return;
    }
    if (!yayinlanabilir.value) {
      formHatasi.value = olcuMetni(engeller.value[0]);
      return;
    }

    const kayit = await kaydet('planlandi', isoyaCevir(planZamani.value));
    useAlert(
      t('ICERIK.OLUSTUR.ZAMANLANDI', {
        zaman: zamanYazisi(kayit?.yayin_zamani || planZamani.value),
      })
    );
  });

// Yayin arka planda surerken gonderiyi yokluyoruz.
//
// NEDEN yoklama: yayin artik is kuyrugunda (web istegi Meta'nin dosya isleme
// suresini bekleyemiyor). Gonderi 'yayinlaniyor' cikip orada kalirsa
// kullanici sonucu goremez.
const YOKLAMA_ARALIGI = 2000;
// Videoda Meta'nin isleme suresi dakikayi bulabiliyor; gorselde saniyeler.
const YOKLAMA_SINIRI = 4 * 60 * 1000;

const yayiniBekle = async id => {
  const bitis = Date.now() + YOKLAMA_SINIRI;
  let son = null;

  while (Date.now() < bitis) {
    await new Promise(c => setTimeout(c, YOKLAMA_ARALIGI));

    // Tek bir yoklamanin patlamasi (ag dalgalanmasi) beklemeyi bitirmemeli;
    // yayin sunucuda surmeye devam ediyor.
    try {
      const { data } = await axios.get(`${uc.value}/${id}`);
      son = data;
      if (data.durum !== 'yayinlaniyor') return data;
    } catch {
      // yoksay, bir sonraki turda tekrar sorulacak
    }
  }

  // Sure doldu: elimizdeki son bilgiyi donuyoruz. Gonderi hala
  // 'yayinlaniyor' olabilir - arayuz bunu oldugu gibi gosterir, yayinlandi
  // demez.
  return son ?? { durum: 'yayinlaniyor' };
};

// YAYINLA: hemen.
const simdiYayinla = () =>
  calistir('yayinla', async () => {
    if (!yayinlanabilir.value) {
      formHatasi.value = olcuMetni(engeller.value[0]);
      return;
    }

    // NEDEN 'taslak' olarak kaydediyoruz: 'planlandi' durumu sunucuda
    // "gelecekte bir an" istiyor, hemen yayinlanacak gonderide boyle bir an
    // yok. Durumu yayin servisi kendisi ilerletiyor.
    const kayit = await kaydet('taslak', null);

    try {
      // Sunucu 202 donuyor: is kuruldu, yayin arka planda suruyor.
      const { data } = await axios.post(`${uc.value}/${kayit.id}/yayinla`);
      gonderiyiUygula(data, { formuDoldur: false });

      const sonuc = await yayiniBekle(kayit.id);
      gonderiyiUygula(sonuc, { formuDoldur: false });
      await imzayiTazele();

      if (sonuc.durum === 'hata') {
        formHatasi.value = t('ICERIK.OLUSTUR.SONUC_HATA_OZET');
        return;
      }

      useAlert(
        sonuc.durum === 'kismi'
          ? t('ICERIK.OLUSTUR.KISMI')
          : t('ICERIK.PAYLASILDI')
      );
    } catch (e) {
      // Tum hedefler patlarsa sunucu 422 ile GONDERININ KENDISINI donuyor.
      // Hedef hatalarini gostermek tek satirlik "islem basarisiz" mesajindan
      // cok daha kullanisli: kullanici hangi hesapta ne oldugunu gorur.
      const govde = e?.response?.data;
      if (govde?.hedefler) {
        gonderiyiUygula(govde, { formuDoldur: false });
        await imzayiTazele();
        formHatasi.value = t('ICERIK.OLUSTUR.SONUC_HATA_OZET');
      } else {
        formHatasi.value = hataMetni(e);
      }
    }
  });

// ONAYA GONDER: temsilci hazirlar, yonetici onaylar. Plan zamani girilmisse
// kayitta kalir; yonetici onayladiginda sunucu o zamana gore planlar, zaman
// yoksa hemen yayinlar.
const onayaGonder = () =>
  calistir('onay', async () => {
    if (!secili.value.length) {
      formHatasi.value = t('ICERIK.OLUSTUR.ENGEL_HESAP_YOK');
      return;
    }
    if (bosMu.value) {
      formHatasi.value = t('ICERIK.OLUSTUR.ENGEL_BOS');
      return;
    }

    let iso = null;
    if (planAcik.value && planZamani.value) {
      const sorun = planSorunu();
      if (sorun) {
        formHatasi.value = sorun;
        return;
      }
      iso = isoyaCevir(planZamani.value);
    }

    // Durum 'taslak' gidiyor: onay ucu gonderiyi kendisi 'onay_bekliyor'
    // yapiyor ve 'planlandi' durumu onaydan once anlamli degil.
    const kayit = await kaydet('taslak', iso);
    const { data } = await axios.post(`${uc.value}/${kayit.id}/onaya`);
    gonderiyiUygula(data, { formuDoldur: false });
    await imzayiTazele();
    useAlert(t('ICERIK.OLUSTUR.ONAYA_GONDERILDI'));
  });

// --- medya -----------------------------------------------------------------

const kutuphaneyiYukle = async () => {
  kutuphaneYukleniyor.value = true;
  kutuphaneHatasi.value = '';
  try {
    const { data } = await axios.get(medyaUcu.value);
    kutuphane.value = data.medya || [];
  } catch (e) {
    kutuphaneHatasi.value = hataMetni(e);
  } finally {
    kutuphaneYukleniyor.value = false;
  }
};

const medyaPaneliniAc = () => {
  medyaPaneli.value = true;
  // Kutuphaneyi yalnizca ilk acilista cekiyoruz; panel her acilisinda ayni
  // listeyi yeniden indirmek gereksiz bekleme.
  if (!kutuphane.value.length) kutuphaneyiYukle();
};

const medyaSec = oge => {
  if (AZAMI_MEDYA === 1) {
    // Tek medya sinirinda yeni secim eskisinin YERINE gecer.
    medya.value = [oge];
  } else if (medya.value.length < AZAMI_MEDYA) {
    medya.value = [...medya.value, oge];
  }

  if (medya.value.length >= AZAMI_MEDYA) medyaPaneli.value = false;
};

const medyaKaldir = kimlik => {
  medya.value = medya.value.filter(m => m.id !== kimlik);
};

const dosyaSecildi = async olay => {
  const dosya = olay.target.files?.[0];
  if (!dosya) return;

  dosyaYukleniyor.value = true;
  kutuphaneHatasi.value = '';
  try {
    const govde = new FormData();
    govde.append('dosya', dosya);
    const { data } = await axios.post(medyaUcu.value, govde);
    kutuphane.value = [data, ...kutuphane.value];
    // Yeni yuklenen dosyayi kullanici zaten bu gonderi icin yukledi; ikinci
    // kez secmesini beklemek gereksiz bir adim.
    medyaSec(data);
  } catch (e) {
    kutuphaneHatasi.value = hataMetni(e);
  } finally {
    dosyaYukleniyor.value = false;
    // Ayni dosyayi arka arkaya secebilmek icin alani bosaltiyoruz; tarayici
    // ayni degeri ikinci kez "degisiklik" saymaz.
    olay.target.value = '';
  }
};

// --- diger -----------------------------------------------------------------

const formuTemizle = async () => {
  gonderiId.value = null;
  gonderiDurumu.value = 'taslak';
  redSebebi.value = '';
  hedefler.value = [];
  metin.value = '';
  medya.value = [];
  secenekler.value = {};
  planAcik.value = false;
  planZamani.value = '';
  formHatasi.value = '';
  secili.value = hesaplar.value.length === 1 ? [hesaplar.value[0].inbox_id] : [];
  await imzayiTazele();

  // Duzenlemeden geldiysek adres hala eski gonderiyi gosteriyor olurdu; bir
  // yenilemede silinmis bir taslaga geri donerdik.
  if (acilistakiId.value || acilistakiZaman.value) {
    router.replace({
      name: 'icerik_olustur',
      params: { accountId: route.params.accountId },
    });
  }
};

const hesabiSec = hesap => {
  secili.value = secili.value.includes(hesap.inbox_id)
    ? secili.value.filter(id => id !== hesap.inbox_id)
    : [...secili.value, hesap.inbox_id];
};

const gelenKutularinaGit = () =>
  router.push({
    name: 'settings_inbox_list',
    params: { accountId: route.params.accountId },
  });

const hedefiAc = hedef => {
  if (hedef.dis_url) window.open(hedef.dis_url, '_blank', 'noopener');
};

// Sekme kapatilirken de uyaralim: rota korumasi yalnizca uygulama icindeki
// gezinmeyi yakalar.
const cikisUyarisi = olay => {
  if (!kirli.value) return;
  olay.preventDefault();
  // Tarayicilar kendi metinlerini gosteriyor; burada yalnizca "sorulsun"
  // demek icin bos bir deger atiyoruz.
  olay.returnValue = '';
};

onBeforeRouteLeave(() => {
  if (!kirli.value) return true;
  return window.confirm(t('ICERIK.OLUSTUR.CIKIS_UYARI'));
});

onMounted(async () => {
  window.addEventListener('beforeunload', cikisUyarisi);
  await hesaplariYukle();

  if (acilistakiId.value) {
    await gonderiyiYukle(acilistakiId.value);
  } else if (acilistakiZaman.value) {
    // Takvimden gelen gun/saat. Gecmis bir ani kabul etmiyoruz: alan zaten
    // gecmisi engelliyor, dolu gelen gecersiz bir deger kullaniciyi
    // "neden kaydedilmiyor" sorusuyla bas basa birakirdi.
    const iso = isoyaCevir(acilistakiZaman.value);
    if (iso && new Date(iso).getTime() > Date.now()) {
      planZamani.value = acilistakiZaman.value;
      planAcik.value = true;
    }
  }

  await imzayiTazele();
});

onBeforeUnmount(() => {
  window.removeEventListener('beforeunload', cikisUyarisi);
});
</script>

<template>
  <div class="flex flex-col w-full">
    <div v-if="hesapYukleniyor" class="flex justify-center p-10">
      <Spinner class="text-n-brand" />
    </div>

    <div v-else-if="hesapHatasi" class="p-6">
      <p class="mb-3 text-sm text-n-ruby-11">{{ hesapHatasi }}</p>
      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-refresh-cw"
        :label="t('ICERIK.YENIDEN_DENE')"
        @click="hesaplariYukle"
      />
    </div>

    <!-- Hic bagli hesap yoksa gonderi hazirlatmanin anlami yok: yazilan metnin
         gidecegi bir yer olmaz. Hesap baglama akisi Ayarlar'da; burada ikinci
         bir akis acmiyoruz. -->
    <div v-else-if="!hesaplar.length" class="p-6">
      <div
        class="max-w-xl p-8 mx-auto text-center border rounded-lg border-n-weak"
      >
        <p class="text-sm font-medium text-n-slate-12">
          {{ t('ICERIK.OLUSTUR.HESAP_YOK_BASLIK') }}
        </p>
        <!-- Temsilci gelen kutusu ayarlarini acamaz; ona dugme gostermek kapali
             bir kapiya yollamak olurdu. -->
        <p class="mt-1 mb-4 text-xs text-n-slate-11">
          {{
            isAdmin
              ? t('ICERIK.HESAP_YOK_ACIKLAMA')
              : t('ICERIK.HESAP_YOK_ACIKLAMA_TEMSILCI')
          }}
        </p>
        <Button
          v-if="isAdmin"
          size="sm"
          variant="solid"
          icon="i-lucide-inbox"
          :label="t('ICERIK.HESAP_YOK_DUGME')"
          @click="gelenKutularinaGit"
        />
      </div>
    </div>

    <div v-else class="flex flex-col gap-5 p-6">
      <div class="flex flex-wrap items-center gap-3">
        <h2 class="text-sm font-medium text-n-slate-12">
          {{
            gonderiId
              ? t('ICERIK.OLUSTUR.BASLIK_DUZENLE')
              : t('ICERIK.OLUSTUR.BASLIK')
          }}
        </h2>
        <span
          v-if="gonderiId"
          class="px-2 py-0.5 text-xs rounded-md"
          :class="DURUM_RENKLERI[gonderiDurumu] || DURUM_RENKLERI.taslak"
        >
          {{ t(DURUM_ANAHTARLARI[gonderiDurumu] || DURUM_ANAHTARLARI.taslak) }}
        </span>
        <span class="grow" />
        <Button
          v-if="gonderiId"
          size="sm"
          variant="faded"
          icon="i-lucide-plus"
          :label="t('ICERIK.OLUSTUR.YENI_ICERIK')"
          @click="formuTemizle"
        />
      </div>

      <!-- 1) Yayinlanacak hesaplar. Ilk adim bu: metnin kime gidecegi, nasil
           gorunecegini de belirliyor. Kutucuk = gercek onay kutusu; klavyeyle
           gezen kullanici da ayni sirayla isaretleyebilsin. -->
      <section class="flex flex-col gap-2">
        <h3 class="text-sm font-medium text-n-slate-12">
          {{ t('ICERIK.OLUSTUR.HESAPLAR_BASLIK') }}
        </h3>
        <div class="flex flex-wrap gap-2">
          <label
            v-for="hesap in hesaplar"
            :key="hesap.inbox_id"
            class="flex items-center gap-2 px-3 py-2 text-sm border rounded-lg cursor-pointer"
            :class="
              secili.includes(hesap.inbox_id)
                ? 'border-n-brand bg-n-alpha-1 text-n-slate-12'
                : 'border-n-weak text-n-slate-11 hover:bg-n-alpha-1'
            "
          >
            <input
              type="checkbox"
              class="!mb-0"
              :checked="secili.includes(hesap.inbox_id)"
              :disabled="kilitli"
              @change="hesabiSec(hesap)"
            />
            <img
              v-if="hesap.gorsel_url"
              :src="hesap.gorsel_url"
              :alt="hesap.ad"
              class="object-cover rounded-full size-6"
            />
            <span class="truncate max-w-[10rem]">{{ hesap.ad }}</span>
            <span
              v-if="platformKurali(hesap.platform)"
              class="size-4"
              :class="[
                platformKurali(hesap.platform).simge,
                platformKurali(hesap.platform).renk,
              ]"
            />
            <span
              v-if="hesap.yayinlanabilir === false"
              class="i-lucide-triangle-alert size-4 text-n-amber-11"
            />
          </label>
        </div>

        <p v-if="sorunluHesaplar.length" class="text-xs text-n-amber-11">
          {{
            t('ICERIK.OLUSTUR.HESAP_YETKI_UYARI', {
              hesaplar: sorunluHesaplar.map(h => h.ad).join(', '),
            })
          }}
        </p>
      </section>

      <!-- 2) Metin + medya solda, canli onizleme sagda. -->
      <div class="grid gap-6 lg:grid-cols-[minmax(0,1fr)_320px]">
        <div class="flex flex-col min-w-0 gap-4">
          <section
            class="flex flex-col gap-3 p-4 border rounded-lg border-n-weak bg-n-surface-1"
          >
            <!-- Yayinlanmis gonderi salt okunur: metni degistirmek Meta'daki
                 gonderiyi degistirmez, yalnizca ekranla gercegi ayristirir. -->
            <textarea
              v-model="metin"
              rows="8"
              class="!mb-0"
              :placeholder="t('ICERIK.OLUSTUR.METIN_YER')"
              :disabled="kilitli"
            />

            <div class="flex flex-wrap items-center gap-3">
              <span
                v-if="sinirKurali"
                class="text-xs"
                :class="sinirAsildi ? 'text-n-ruby-11' : 'text-n-slate-11'"
              >
                {{
                  t('ICERIK.OLUSTUR.SAYAC', {
                    uzunluk: metinUzunlugu,
                    sinir: sinirKurali.metinSiniri,
                    platform: t(sinirKurali.anahtar),
                  })
                }}
              </span>
              <span class="grow" />
              <Button
                size="sm"
                variant="faded"
                icon="i-lucide-image"
                :label="t('ICERIK.OLUSTUR.MEDYA_EKLE')"
                :disabled="!medyaEklenebilir || kilitli"
                @click="medyaPaneliniAc"
              />
            </div>

            <div v-if="medya.length" class="flex flex-wrap gap-3">
              <div
                v-for="oge in medya"
                :key="oge.id"
                class="relative w-24 overflow-hidden border rounded-lg border-n-weak"
              >
                <img
                  v-if="oge.tur === 'gorsel'"
                  :src="oge.url"
                  :alt="oge.ad"
                  class="object-cover w-24 h-24"
                />
                <span
                  v-else
                  class="grid w-24 h-24 place-content-center bg-n-alpha-1 text-n-slate-11"
                >
                  <span class="i-lucide-video size-6" />
                </span>
                <button
                  v-if="!kilitli"
                  type="button"
                  class="absolute grid text-white rounded-full top-1 right-1 size-5 place-content-center bg-n-alpha-black2"
                  :title="t('ICERIK.OLUSTUR.MEDYA_KALDIR')"
                  @click="medyaKaldir(oge.id)"
                >
                  <span class="i-lucide-x size-3" />
                </button>
              </div>
            </div>

            <!-- Tek dosya siniri arka uctan geliyor; sebebini yaziyoruz ki
                 "neden ikinci gorseli ekleyemiyorum" sorusu dogmasin. -->
            <p class="text-xs text-n-slate-11">
              {{ t('ICERIK.OLUSTUR.MEDYA_TEK_NOT') }}
            </p>
          </section>

          <!-- Engeller: yayini durduran seyler. -->
          <div v-if="engeller.length" class="flex flex-col gap-1">
            <p
              v-for="(engel, sira) in engeller"
              :key="sira"
              class="flex items-start gap-2 text-xs text-n-ruby-11"
            >
              <span class="mt-px shrink-0 i-lucide-circle-alert size-3.5" />
              <span>{{ olcuMetni(engel) }}</span>
            </p>
          </div>

          <!-- Uyarilar: gonderi cikar ama beklendigi gibi cikmaz. -->
          <div v-if="uyarilar.length" class="flex flex-col gap-1">
            <p
              v-for="(uyari, sira) in uyarilar"
              :key="sira"
              class="flex items-start gap-2 text-xs text-n-amber-11"
            >
              <span class="mt-px shrink-0 i-lucide-info size-3.5" />
              <span>{{ olcuMetni(uyari) }}</span>
            </p>
          </div>

          <!-- Yonetici reddettiyse sebebi burada; duzeltilecek sey bu. -->
          <p
            v-if="redSebebi"
            class="flex items-start gap-2 p-3 text-xs rounded-lg bg-n-alpha-1 text-n-amber-11"
          >
            <span class="mt-px shrink-0 i-lucide-triangle-alert size-3.5" />
            <span>{{ t('ICERIK.RED_SEBEBI', { sebep: redSebebi }) }}</span>
          </p>

          <!-- 3) Platforma ozel bolumler: secili platform basina bir kez. -->
          <IcerikPlatformSecenek
            v-for="platformAdi in aktifPlatformlar"
            :key="platformAdi"
            :platform="platformAdi"
            :model-value="secenekler[platformAdi] || {}"
            :hesaplar="platformHesaplari(platformAdi)"
            :medya="medya"
            :kilitli="kilitli"
            @update:model-value="deger => ayariYaz(platformAdi, deger)"
          />

          <!-- Yayin sonuclari: HER HEDEF ayri satir. Gonderinin Instagram'a
               gidip Facebook'a gitmemesi olagan; tek bir "basarili/basarisiz"
               satiri bunu anlatamaz. -->
          <section
            v-if="hedefler.length && gonderiDurumu !== 'taslak'"
            class="flex flex-col gap-2 p-4 border rounded-lg border-n-weak bg-n-surface-1"
          >
            <h3 class="text-sm font-medium text-n-slate-12">
              {{ t('ICERIK.OLUSTUR.SONUC_BASLIK') }}
            </h3>
            <div
              v-for="hedef in hedefler"
              :key="hedef.id"
              class="flex flex-wrap items-center gap-2 text-xs"
            >
              <span class="font-medium text-n-slate-12">
                {{ hedef.ad || t('ICERIK.HESAP_SILINMIS') }}
              </span>
              <span :class="HEDEF_DURUM_RENKLERI[hedef.durum]">
                {{
                  t(
                    HEDEF_DURUM_ANAHTARLARI[hedef.durum] ||
                      HEDEF_DURUM_ANAHTARLARI.bekliyor
                  )
                }}
              </span>
              <Button
                v-if="hedef.dis_url"
                size="xs"
                variant="link"
                icon="i-lucide-external-link"
                :label="t('ICERIK.DIS_BAGLANTI')"
                @click="hedefiAc(hedef)"
              />
              <span v-if="hedef.hata" class="w-full text-n-ruby-11">
                {{ hedef.hata }}
              </span>
            </div>
          </section>

          <p v-if="formHatasi" class="text-sm text-n-ruby-11">
            {{ formHatasi }}
          </p>

          <!-- 4) Eylemler. Yayinlanmis gonderide hicbiri yok: yapilacak tek
               is yeni bir icerik acmak. -->
          <section v-if="kilitli" class="flex flex-wrap items-center gap-3">
            <p class="text-xs text-n-slate-11">
              {{ t('ICERIK.OLUSTUR.KILITLI_NOT') }}
            </p>
            <Button
              size="sm"
              variant="solid"
              icon="i-lucide-plus"
              :label="t('ICERIK.OLUSTUR.YENI_ICERIK')"
              @click="formuTemizle"
            />
          </section>

          <section v-else class="flex flex-col gap-3">
            <div v-if="planAcik" class="flex flex-wrap items-end gap-3">
              <label class="text-sm text-n-slate-11">
                {{ t('ICERIK.OLUSTUR.PLAN_ZAMAN') }}
                <input
                  v-model="planZamani"
                  type="datetime-local"
                  :min="enErkenZaman()"
                />
              </label>
              <Button
                size="sm"
                variant="solid"
                icon="i-lucide-calendar-clock"
                :label="t('ICERIK.OLUSTUR.PLANLA_KAYDET')"
                :is-loading="islemde('planla')"
                :disabled="kaydediliyor"
                @click="planKaydet"
              />
              <Button
                size="sm"
                variant="ghost"
                color="slate"
                :label="t('ICERIK.OLUSTUR.PLANLA_VAZGEC')"
                :disabled="kaydediliyor"
                @click="planAcik = false"
              />
            </div>

            <div class="flex flex-wrap items-center gap-2">
              <Button
                size="sm"
                variant="faded"
                icon="i-lucide-save"
                :label="t('ICERIK.OLUSTUR.TASLAK')"
                :is-loading="islemde('taslak')"
                :disabled="kaydediliyor"
                @click="taslakKaydet"
              />
              <Button
                size="sm"
                variant="faded"
                icon="i-lucide-send"
                :label="t('ICERIK.OLUSTUR.ONAYA')"
                :is-loading="islemde('onay')"
                :disabled="kaydediliyor"
                @click="onayaGonder"
              />
              <Button
                v-if="!planAcik"
                size="sm"
                variant="faded"
                icon="i-lucide-calendar-clock"
                :label="t('ICERIK.OLUSTUR.PLANLA')"
                :disabled="kaydediliyor"
                @click="planAcik = true"
              />
              <Button
                size="sm"
                variant="solid"
                icon="i-lucide-upload"
                :label="t('ICERIK.OLUSTUR.YAYINLA')"
                :is-loading="islemde('yayinla')"
                :disabled="kaydediliyor || !yayinlanabilir"
                @click="simdiYayinla"
              />
            </div>

            <!-- Kapali dugmenin sebebini YAZIYORUZ. Sebepsiz kapali bir dugme,
                 kullaniciyi neyi duzeltecegini bilmeden birakir. -->
            <p v-if="!yayinlanabilir" class="text-xs text-n-slate-11">
              {{ olcuMetni(engeller[0]) }}
            </p>
          </section>
        </div>

        <IcerikOnizleme
          :metin="metin"
          :medya="medya"
          :hesaplar="seciliHesaplar"
          :secenekler="secenekler"
        />
      </div>
    </div>

    <!-- Medya secici: yukleme + kutuphane tek yerde. Gonderi hazirlarken
         kutuphane ekranina gitmek, yazilan metni birakip gitmek demekti. -->
    <div
      v-if="medyaPaneli"
      class="fixed inset-0 z-50 flex items-center justify-center p-6 bg-n-alpha-black2"
      @click.self="medyaPaneli = false"
    >
      <div
        class="w-full max-w-2xl max-h-[80vh] overflow-auto border rounded-lg bg-n-surface-1 border-n-weak"
      >
        <div class="flex items-center gap-2 px-4 py-3 border-b border-n-weak">
          <h3 class="text-sm font-medium text-n-slate-12">
            {{ t('ICERIK.OLUSTUR.MEDYA_PANEL_BASLIK') }}
          </h3>
          <span class="grow" />
          <Button
            size="sm"
            variant="faded"
            :label="t('ICERIK.KAPAT')"
            @click="medyaPaneli = false"
          />
        </div>

        <div class="flex flex-col gap-4 p-4">
          <label
            class="flex items-center gap-2 px-3 py-2 text-sm border border-dashed rounded-lg cursor-pointer border-n-weak text-n-slate-11 hover:bg-n-alpha-1"
          >
            <span class="i-lucide-upload size-4" />
            {{
              dosyaYukleniyor
                ? t('ICERIK.OLUSTUR.MEDYA_YUKLENIYOR')
                : t('ICERIK.OLUSTUR.MEDYA_YUKLE')
            }}
            <input
              type="file"
              class="hidden"
              accept="image/jpeg,image/png,image/webp,video/mp4"
              :disabled="dosyaYukleniyor"
              @change="dosyaSecildi"
            />
          </label>

          <p v-if="kutuphaneHatasi" class="text-xs text-n-ruby-11">
            {{ kutuphaneHatasi }}
          </p>

          <div v-if="kutuphaneYukleniyor" class="flex justify-center p-6">
            <Spinner class="text-n-brand" />
          </div>

          <p
            v-else-if="!kutuphane.length"
            class="p-6 text-xs text-center text-n-slate-11"
          >
            {{ t('ICERIK.OLUSTUR.MEDYA_KUTUPHANE_BOS') }}
          </p>

          <div v-else class="grid grid-cols-4 gap-3">
            <button
              v-for="oge in kutuphane"
              :key="oge.id"
              type="button"
              class="overflow-hidden text-left border rounded-lg border-n-weak hover:border-n-brand"
              @click="medyaSec(oge)"
            >
              <img
                v-if="oge.tur === 'gorsel'"
                :src="oge.url"
                :alt="oge.ad"
                class="object-cover w-full h-20"
              />
              <span
                v-else
                class="grid w-full h-20 place-content-center bg-n-alpha-1 text-n-slate-11"
              >
                <span class="i-lucide-video size-5" />
              </span>
              <span
                class="block px-2 py-1 text-[11px] truncate text-n-slate-11"
              >
                {{ oge.ad }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
